import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTPrintLogListItem extends SearchModelBase {
    senderId: string = '';
    title: string = '';
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    refNo: string = '';
    hblNo: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Ref #', width: 100, dataIndex: 'refNo' }),
        XCol.Create({ col: 2, text: 'HBL #', width: 100, dataIndex: 'hblNo' }),
        XCol.Create({ col: 3, text: 'User Name', width: 80, dataIndex: 'senderId'}),
        XCol.Create({ col: 4, text: 'Title', width: 500, dataIndex: 'title', defaultColumnFocus:true}),
        XCol.Create({ col: 5, text: 'Date', width: 120, dataIndex: 'postDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTPrintLogListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: UTPrintLogListItem[]) {
        return data.map((d: UTPrintLogListItem, index: number) => ({
          ...d,
          id: index + 1 //for cell focus
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      postDate: {from: 'fromPostDate', to: 'toPostDate'},
    }
}
